'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActiveChannel = exports.getServerTimeOffsetInMs = exports.getIsInForeground = exports.getCanPublishMessage = exports.getDisplayResponderOnline = exports.getSessionStartedAt = exports.getSubscribeConfirmationTimestamp = exports.getIsAgentReady = exports.getIsAdmin = exports.getUuid = exports.getChatConfig = exports.isPubNubConnected = exports.isForcedOffline = exports.isMobile = undefined;
exports.isActiveOnChannel = isActiveOnChannel;

var _reselect = require('reselect');

var _widgetDataSelectors = require('conversations-core/selectors/widgetDataSelectors');

var _conversationSelectors = require('conversations-core/selectors/conversationSelectors');

var _outgoingMessagesSelectors = require('conversations-core/selectors/outgoingMessagesSelectors');

var _transmute = require('transmute');

var isMobile = exports.isMobile = function isMobile(state) {
  return state.clientData.isMobile;
};
var isForcedOffline = exports.isForcedOffline = function isForcedOffline(state) {
  return state.clientData.forceClientOffline;
};
var isPubNubConnected = exports.isPubNubConnected = function isPubNubConnected(state) {
  return state.clientData.isPubNubClientConnected;
};

var getChatConfig = exports.getChatConfig = function getChatConfig(state) {
  return state.clientData.chatConfig;
};
var getUuid = exports.getUuid = function getUuid(state) {
  return state.clientData.uuid;
};
var getIsAdmin = exports.getIsAdmin = function getIsAdmin(state) {
  return state.clientData.isAdmin;
};

var getIsAgentReady = exports.getIsAgentReady = (0, _transmute.getIn)(['clientData', 'chatConfig', 'agentReady']);

var getSubscribeConfirmationTimestamp = exports.getSubscribeConfirmationTimestamp = (0, _transmute.getIn)(['clientData', 'timestamps', 'subscribeConfirmation']);

var getSessionStartedAt = exports.getSessionStartedAt = (0, _transmute.getIn)(['clientData', 'sessionStartedAt']);

var getDisplayResponderOnline = exports.getDisplayResponderOnline = (0, _reselect.createSelector)([_widgetDataSelectors.isResponderOnline, isForcedOffline], function (responderOnline, forcedOffline) {
  return Boolean(responderOnline && !forcedOffline);
});

var getCanPublishMessage = exports.getCanPublishMessage = (0, _reselect.createSelector)([isPubNubConnected, getIsAdmin, getIsAgentReady, _outgoingMessagesSelectors.getIsPublishing, _widgetDataSelectors.getIsOnlineMode, _widgetDataSelectors.getIsRestrictedToMaxConcurrentChats], function (pubNubConnected, isAdmin, agentIsReady, isPublishing, isOnlineMode, isRestrictedToMaxConcurrentChats) {
  if (!pubNubConnected) return false;

  if (isAdmin) return !isPublishing;

  if (isRestrictedToMaxConcurrentChats) {
    return isOnlineMode && agentIsReady && !isPublishing;
  }

  return isOnlineMode && !isPublishing;
});

var getIsInForeground = exports.getIsInForeground = function getIsInForeground(state) {
  return state.clientData.isInForeground;
};

var getServerTimeOffsetInMs = exports.getServerTimeOffsetInMs = function getServerTimeOffsetInMs(state) {
  return state.clientData.serverTimeOffsetInMs;
};

function isActiveOnChannel(state, channel) {
  var currentChannel = state.currentChannel;

  return channel === currentChannel && getIsInForeground(state);
}

var getActiveChannel = exports.getActiveChannel = (0, _reselect.createSelector)([getIsInForeground, _conversationSelectors.getCurrentChannel], function (isInForeground, currentChannel) {
  if (isInForeground) return currentChannel;
  return null;
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/selectors/clientSelectors.js
// module id = 14
// module chunks = 0 1